module.exports = __webpack_public_path__ + "static/media/proceso-03-almacenamos.90a9435f.svg";